import React, { useEffect, useRef, useState } from "react";
import styles from "../Form.module.scss";

function TextInput({
  substep,
  value,
  onChange,
  error,
  isReadOnly,
  isPassword,
  allowReveal = true,
  multiline,
  digitsOnly = false,
  exactLength,
  allowEmpty = false,
}) {
  const config = substep?.input_text ?? {};
  const text = value?.string_value ?? "";
  const maxLength = exactLength ?? (config.max_length > 0 ? config.max_length : undefined);
  const [revealed, setRevealed] = useState(false);
  const textareaRef = useRef(null);
  const localError =
    exactLength &&
    text.length > 0 &&
    (text.length !== exactLength || (digitsOnly && !/^\d+$/.test(text)))
      ? `Enter exactly ${exactLength} digits${allowEmpty ? " or leave this field blank" : ""}`
      : null;
  const visibleError = error || localError;

  useEffect(() => {
    if (!multiline || !textareaRef.current) return;
    textareaRef.current.style.height = "auto";
    textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
  }, [multiline, text]);

  const handleChange = (e) => {
    const rawValue = e.target.value;
    const digits = digitsOnly ? rawValue.replace(/\D/g, "") : rawValue;
    const normalizedValue = maxLength ? digits.slice(0, maxLength) : digits;
    onChange(substep.substep_id, { string_value: normalizedValue });
  };

  if (multiline) {
    return (
      <div className={styles.fieldBody}>
        <textarea
          ref={textareaRef}
          className={`${styles.input} ${styles.textareaInput} ${visibleError ? styles.inputError : ""}`}
          value={text}
          placeholder={config.placeholder || ""}
          maxLength={maxLength}
          disabled={isReadOnly}
          autoCapitalize="none"
          autoComplete="off"
          rows={2}
          onChange={handleChange}
        />
        {visibleError && <div className={styles.fieldError}>{visibleError}</div>}
      </div>
    );
  }

  return (
    <div className={styles.fieldBody}>
      <div className={isPassword && allowReveal ? styles.passwordWrap : undefined}>
        <input
          className={`${styles.input} ${visibleError ? styles.inputError : ""}`}
          type={isPassword && !revealed ? "password" : "text"}
          inputMode={digitsOnly ? "numeric" : undefined}
          pattern={digitsOnly ? "[0-9]*" : undefined}
          value={text}
          placeholder={config.placeholder || ""}
          maxLength={maxLength}
          disabled={isReadOnly}
          autoCapitalize="none"
          autoComplete="off"
          onChange={handleChange}
        />
        {isPassword && allowReveal && (
          <button
            type="button"
            className={styles.eyeBtn}
            onClick={() => setRevealed((v) => !v)}
            tabIndex={-1}
            aria-label={revealed ? "Hide" : "Show"}
          >
            <img src={revealed ? "/logos/eye_open.svg" : "/logos/eye_close.svg"} alt="" />
          </button>
        )}
      </div>
      {visibleError && <div className={styles.fieldError}>{visibleError}</div>}
    </div>
  );
}

export default TextInput;
